// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownloadOutlinedSvg from "@ant-design/icons-svg/es/asn/DownloadOutlined";
import AntdIcon from '../components/AntdIcon';

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownloadOutlinedSvg
  }));
};

DownloadOutlined.displayName = 'DownloadOutlined';
export default React.forwardRef(DownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DownloadOutlined.js
// module id = 985
// module chunks = 0